module.exports = __webpack_public_path__ + "static/produksiyon-ust-gorsel-cdb70f7a44e0b9b08c684a0b06be2a03.webp";